// project import

import { useRoutes } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import { useSelector } from 'react-redux';
import Loader from 'components/Loader';
import LoginRoutes from './LoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function Routes() {
  const { isLoading, userDetails } = useSelector((state) => state.user);

  return useRoutes(isLoading ? [{ path: '*', element: <Loader /> }] : [MainRoutes(userDetails), LoginRoutes(userDetails)]);
}
